import {isNil, join, pipe, reject} from 'ramda';
import {isNilOrEmpty, isNonEmptyString} from 'ramda-adjunct';

import {GetApiMakeModelWithMakeApiResponse} from '@dms/api/shared';
import {i18n} from '@dms/i18n';

import {Nullish} from 'shared/web';

type Vehicle = {
  make?: string | null;
  modelFamily?: string | null;
  trim?: string | null;
  variant?: string | null;
  title?: string | null;
};

export function getVehicleTitle(
  vehicle: Vehicle,
  makeModels?: GetApiMakeModelWithMakeApiResponse | Nullish
) {
  if (isNonEmptyString(vehicle.title)) {
    return vehicle.title;
  }

  const language = i18n?.resolvedLanguage ?? 'en';

  const makeModel = makeModels?.find((makeModel) => makeModel.make === vehicle.make);

  if (isNil(makeModel)) {
    return null;
  }

  const make = getLabel(makeModel, language);
  const modelFamily = getLabel(
    makeModel.models?.find((model) => model.model === vehicle.modelFamily),
    language
  );

  return pipe(reject(isNilOrEmpty), join(' '))([make, modelFamily, vehicle.trim, vehicle.variant]);
}

type LabelType = {
  default_label: string;
  labels?: {
    label: string;
    label_short?: string | null;
    language: string;
  }[];
};

const getLabel = (vehicleModel: LabelType | Nullish, language: string) =>
  vehicleModel?.labels?.find((label) => label.language.toUpperCase() === language.toUpperCase())
    ?.label ?? vehicleModel?.default_label;
